module.exports = __webpack_public_path__ + "static/media/stop.6e19155a.png";